import React, { useRef, useEffect } from 'react';

const FeesStep = ({ formData, setFormData, errors, onNext, onBack }) => {
  const sliderRef = useRef(null);
  const spanRef = useRef(null);

  const handleSliderInput = (e) => {
    const newValue = parseFloat(e.target.value);
    // console.log("newValuee", newValue)
    setFormData(prev => ({ ...prev, creatorFee: newValue }));
  };

  const updateLabelPosition = () => {
    const slider = sliderRef.current;
    const label = spanRef.current;
    if (!slider || !label) return;
    const sliderWidth = slider.offsetWidth;
    const min = parseFloat(slider.min);
    const max = parseFloat(slider.max);
    const percent = (formData.creatorFee - min) / (max - min);
    const thumbSize = 20;
    const offset = percent * (sliderWidth - thumbSize) + thumbSize / 2;
    label.style.left = `${offset}px`;
  };

  useEffect(() => {
    updateLabelPosition();
    // console.log(formData, "FormData")
  }, [formData.creatorFee]);

  return (
    <>
      <div className="wrappermain forpadd">
        <div className="textformobile">
          <div className="parentmbl d-none">
            <div className="parent">
              <h6>Fees</h6>
              <button>2/4</button>
            </div>
          </div>
        </div>
        <h2 className="createrpara">Creator Fee %</h2>
        <div className="fee-slider">
          {/* <label className="slider-label">Creator Fee %</label> */}
          <div className="slider-wrapper">
            <input
              ref={sliderRef}
              type="range"
              min="0"
              max="2.5"
              step="0.1"
              value={formData.creatorFee}
              onChange={handleSliderInput}
              className="custom-slider"
              style={{
                background: `linear-gradient(to right, #4B5AFF ${(formData.creatorFee / 2.5) * 100}%, var(--slider) ${(formData.creatorFee / 2.5) * 100}%)`
              }}
            />
            <span
              ref={spanRef}
              className="slider-tooltip"
              style={{ left: `${(formData.creatorFee / 2.5) * 100}%` }}
            >
              {formData.creatorFee}%
            </span>
          </div>
          <div className="slider-minmax">
            <span>0%</span>
            <span>2.5%</span>
          </div>
          {errors.creatorFee && <p className="error-text">{errors.creatorFee}</p>}
        </div>
      </div>
      <div className="bottom-btns">
        <button className="backbtnbtn" onClick={onBack}>Back</button>
        <button onClick={onNext} className="continuebtn">Continue</button>
      </div>
    </>
  );
};

export default FeesStep;
